export enum AppConfigConstants {
  ATS_CLIENT_TYPE = "ATSClientType",
	API_SERVER_URL = "APIServerURL",
	RECAPTCHA_LOAD_URL = "ReCaptchaLoadURL",
	RECAPTCHA_SITE_KEY = "ReCaptchaSitekey",
  RECAPTCHA_URL_SEGMENT = "ReCaptchaURLSegment",
  LOGIN_URL_SEGMENT = "LoginURLSegment",
  APPLICANT_URL_SEGMENT = "ApplicantURLSegment",
  ADMINISTRATION_URL_SEGMENT = "AdministrationURLSegment",
  APPLICATION_URL_SEGMENT = "ApplicationURLSegment",
  USER_URL_SEGMENT = "UserURLSegment",
  LOOKUP_URL_SEGMENT = "LookupURLSegment",
  REPORT_URL_SEGMENT = "ReportURLSegment",
  FOOTER_PRIVACY_STATEMENT_URL = "footerPrivacyStatementURL",
  FOOTER_EMAIL_NOTICE_URL = "footerEmailNoticeURL",
  FOOTER_DISCLAIMER_URL = "footerDisclaimerURL",
  FOOTER_CONTACT_URL = "footerContactURL",
  FOOTER_ADA_URL = "footerADAURL",
  RE_SUBMISSION_THRESHOLD_IN_MONTHS = "resubmissionThresholdInMonths",
  IN_VALID_FILE_TYPES = "inValidFileTypes",
  PAGE_SIZE = "pageSize",
}
